<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <h3 class="mb-5">Papildomi duomenys sandorio sudarymui</h3>

    <template v-if="!showSandoris && !pageloading">
      <el-button primary @click.native="gotoHipotekaPranesimas()"
        >Pasirinkite veiksmą "Sudarymas"</el-button
      >
    </template>
    <template v-if="showSandoris">
      <div class="dataContainer">
        <v-row>
          <v-col cols="12">
            <h4 class="mb-3">
              BENDROSIOS SĄLYGOS<el-tooltip
                inline
                tooltip="Hipoteka. Sandoris. Bendrosios sąlygos"
              />
            </h4>
          </v-col>

          <v-col cols="12">
            <draggable
              :list="papildomiSalygosActive"
              @update="dragItems(papildomiSalygosActive)"
              :disabled="!enableDrag || !dragSalygosHover"
            >
              <v-row
                no-gutters
                v-for="(item, index) in papildomiSalygosActive"
                :key="index"
              >
                <v-col cols="12">
                  <el-textarea
                    :label="item.pap_pavadinimas"
                    tooltip2="Hipoteka. Sandoris. Papildomas laukas"
                    :validate-key="`papsalygos-${item.pap_order_nr}`"
                    :counter="4000"
                    :readonly="isReadonlyForm"
                    v-model="item.pap_informacija"
                    :append-outer-icon="!isReadonlyForm ? 'mdi-delete' : ''"
                    @clickAppendOuter="deletePapildomasLaukas(item)"
                  >
                    <template v-slot:prepend>
                      <v-icon
                        v-if="showDragSalygos"
                        class="drag-icon"
                        @mouseenter="dragSalygosHover = true"
                        @mouseleave="dragSalygosHover = false"
                      >
                        mdi-arrow-up-down
                      </v-icon>
                    </template>
                  </el-textarea>
                </v-col>
              </v-row>
            </draggable>
          </v-col>

          <v-col cols="12">
            <el-button
              small
              v-if="!isReadonlyForm"
              @click.native="openPapildomasLaukas(tipasSalygos)"
              :loading="loading || adding"
              >Pridėti papildomą lauką</el-button
            >
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h4 class="mb-3">
              KITA INFORMACIJA<el-tooltip
                inline
                tooltip="Hipoteka. Sandoris. Kita informacija"
              />
            </h4>
          </v-col>
          <v-col cols="12">
            <draggable
              :list="papildomiKitaActive"
              @update="dragItems(papildomiKitaActive)"
              :disabled="!enableDrag || !dragKitaHover"
            >
              <v-row
                no-gutters
                v-for="(item, index) in papildomiKitaActive"
                :key="index"
              >
                <v-col cols="12">
                  <el-textarea
                    :label="item.pap_pavadinimas"
                    tooltip2="Hipoteka. Sandoris. Papildomas laukas"
                    :validate-key="`papkita-${index}`"
                    :counter="4000"
                    :readonly="isReadonlyForm"
                    v-model="item.pap_informacija"
                    :append-outer-icon="!isReadonlyForm ? 'mdi-delete' : ''"
                    @clickAppendOuter="deletePapildomasLaukas(item)"
                  >
                    <template v-slot:prepend>
                      <v-icon
                        v-if="showDragKita"
                        class="drag-icon"
                        @mouseenter="dragKitaHover = true"
                        @mouseleave="dragKitaHover = false"
                      >
                        mdi-arrow-up-down
                      </v-icon>
                    </template>
                  </el-textarea>
                </v-col>
              </v-row>
            </draggable>
          </v-col>
          <v-col cols="12">
            <el-button
              small
              v-if="!isReadonlyForm"
              @click.native="openPapildomasLaukas(tipasKita)"
              :loading="loading || adding"
              >Pridėti papildomą lauką</el-button
            >
          </v-col>
        </v-row>
      </div>
      <hipoteka-istorija duomenys="sandoris" />

      <v-footer class="form-footer">
        <el-button
          v-if="!isReadonlyForm"
          primary
          @click.native="saveData()"
          :loading="loading"
          >Saugoti</el-button
        >
        <el-button
          v-if="!isReadonlyForm"
          @click.native="cancelData()"
          :loading="loading"
          >Atšaukti</el-button
        >
        <v-spacer></v-spacer>
        <el-button
          v-if="!isReadonlyForm"
          primary
          @click.native="checkErrorsClick()"
          :loading="loading"
          >Tikrinti</el-button
        >
      </v-footer>

      <modal-papildomas-laukas
        :key="`sandpap-${refreshPapildomasLaukas}`"
        tooltip="Hipoteka. Sandoris. Modalas papildomas laukas"
        v-model="showPapildomasLaukas"
        @confirmPapildomasLaukas="confirmPapildomasLaukas"
      />
      <modal-delete
        title="Šalinti lauką?"
        :text="
          `Ar norite pašalinti lauką <strong>${modalDeleteVardas}</strong>?`
        "
        v-model="showDelete"
        :item="modalDeleteItem"
        @confirmDelete="confirmDelete"
      />
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import ModalPapildomasLaukas from '../modals/ModalPapildomasLaukas'
import ModalDelete from '../modals/ModalDelete'
import unsavedData from '../../mixins/unsavedData'
import checkErrors from '../../mixins/checkErrors'
import HipotekaIstorija from './istorija/HipotekaIstorija'

export default {
  name: 'HipotekaSandoris',
  components: {
    draggable,
    ModalPapildomasLaukas,
    ModalDelete,
    HipotekaIstorija,
  },
  mixins: [unsavedData, checkErrors],
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        sandoris: {},
        papildomi: [],
      },
      loading: true,
      adding: false,
      pageloading: true,
      showPapildomasLaukas: false,
      refreshPapildomasLaukas: 0,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      papildomasTipas: null,
      dragSalygos: null,
      dragKita: null,
      dragSalygosHover: false,
      dragKitaHover: false,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas', 'hipotekaReadonly']),
    isReadonlyForm() {
      return this.hipotekaReadonly || this.readonlyForm
    },
    showSandoris() {
      return this.formData.sandoris.obj_veiksmas === 1
    },
    enableDrag() {
      return !this.isReadonlyForm && true
    },
    showDragSalygos() {
      return !this.isReadonlyForm && this.papildomiSalygosActive.length > 1
    },
    showDragKita() {
      return !this.isReadonlyForm && this.papildomiKitaActive.length > 1
    },
    tipasSalygos() {
      return 'salygos'
    },
    tipasKita() {
      return 'kita'
    },
    papildomiSalygosActive() {
      return this.formData.papildomi
        .filter(item => {
          return item.pap_tipas === this.tipasSalygos && !item.deleted
        })
        .sort((a, b) => {
          if (a.pap_order_nr > b.pap_order_nr) return 1
          if (a.pap_order_nr < b.pap_order_nr) return -1
          return 0
        })
    },
    papildomiKitaActive() {
      return this.formData.papildomi
        .filter(item => {
          return item.pap_tipas === this.tipasKita && !item.deleted
        })
        .sort((a, b) => {
          if (a.pap_order_nr > b.pap_order_nr) return 1
          if (a.pap_order_nr < b.pap_order_nr) return -1
          return 0
        })
    },
    papildomiReload() {
      return (
        this.formData.papildomi.filter(item => {
          return !item.pap_id || item.deleted
        }).length > 0
      )
    },
  },
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`objektas/${this.objektasID}/sandorioinformacija`)
        .then(res => {
          this.initData(res.data)
          this.getPapildomiLaukai()
        })
        .catch(err => {
          this.loading = false
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    initData(data) {
      this.formData = {
        sandoris: data.sandorio_informacija,
        papildomi: data.papildomi_laukai.map(item => {
          item.deleted = false
          return item
        }),
      }
    },
    async getPapildomiLaukai() {
      try {
        // sequence
        for (let laukas of this.formData.papildomi) {
          if (laukas.pap_id) {
            const res = await this.$axios.get(
              `objektas/${this.objektasID}/papildomas/${laukas.pap_id}`
            )
            laukas.pap_informacija = res.data.papildomas_laukas.pap_informacija
          }
        }
        this.initialForm()
        this.loading = false
        this.pageloading = false
      } catch (err) {
        this.loading = false
        window._VMA.$emit('DATA_ERROR', err.response.data.message)
      }
    },
    saveData(toRoute, afterSave) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          const data = this.formData.sandoris

          this.$axios
            .post(`objektas/${this.objektasID}/sandorioinformacija`, data)
            .then(res => {
              this.savePapildomiLaukai(toRoute, afterSave)
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    async savePapildomiLaukai(toRoute, afterSave) {
      try {
        for (let laukas of this.formData.papildomi) {
          if (!laukas.deleted) {
            const data = { ...laukas }
            await this.$axios
              .post(`objektas/${this.objektasID}/papildomas`, data)
              .then(res => {
                laukas.pap_id = res.data.pap_id
              })
          } else {
            if (laukas.pap_id) {
              await this.$axios
                .delete(
                  `objektas/${this.objektasID}/papildomas/${laukas.pap_id}`
                )
                .then(res => {
                  //
                })
                .catch(err => {
                  //
                })
            }
          }
        }

        window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')
        if (toRoute) {
          this.goToRoute()
          this.loading = false
        } else {
          if (this.papildomiReload) {
            this.getData()
          } else {
            this.initialForm()
            this.loading = false
          }

          if (afterSave === 'checkErrors') {
            this.checkErrors()
          }
        }
      } catch (err) {
        window._VMA.$emit('DATA_ERROR', err.response.data.message)
      }
    },
    cancelData() {
      this.getData()
    },
    openPapildomasLaukas(tipas) {
      this.refreshPapildomasLaukas++
      this.papildomasTipas = tipas
      this.showPapildomasLaukas = true
    },
    confirmPapildomasLaukas(newLaukas) {
      this.formData.papildomi.push({
        obj_id: this.objektasID,
        pap_id: null,
        pap_tipas: this.papildomasTipas,
        pap_order_nr: this.formData.papildomi.length,
        pap_pavadinimas: newLaukas,
        pap_informacija: null,
        deleted: false,
      })
    },
    deletePapildomasLaukas(item) {
      this.modalDeleteVardas = item.pap_pavadinimas ?? ''
      this.modalDeleteItem = item
      this.showDelete = true
    },
    confirmDelete(item) {
      item.deleted = true
    },
    gotoHipotekaPranesimas() {
      this.$router.push({
        name: 'hipotekaPranesimas',
        params: {
          objektasID: this.objektasID,
        },
      })
    },
    checkErrorsClick() {
      this.saveData(null, 'checkErrors')
    },
    chunkArray(fullArray, chunk_size) {
      var results = []
      while (fullArray.length) {
        results.push(fullArray.splice(0, chunk_size))
      }
      return results
    },
    dragItems(items) {
      items.forEach((item, index) => {
        item.pap_order_nr = index
      })
      this.dragSalygosHover = false
      this.dragKitaHover = false
    },
  },
}
</script>
<style lang="scss" scoped>
.drag-icon {
  background: none;
  cursor: pointer;
  height: 32px;
  width: 32px;
  font-size: 20px !important;
}
</style>
